export default __webpack_public_path__ + "static/media/protected.dcbd31d2.svg";